export default __webpack_public_path__ + "static/media/group.12dc42c7.svg";